import { API } from "aws-amplify";
import { processConfig as process } from "../../config/env";

const ORDER_API_NAME = process.env.BACK_API_NOAUTH_NAME;

export function checkWebviewerFileStatus({ bucket, key }) {
  return API.get(ORDER_API_NAME, "/checkWebviewerFileStatus", {
    queryStringParameters: {
      bucket,
      key
    },
  });
}
